<template>
  <!-- 论文推荐-->
  <div class="commends" v-if="list_data.length != 0">
    <div class="column_list">
      <img src="@/assets/image/paper_recommendations.png" />
      <h3>论文推荐</h3>
    </div>
    <!-- <Scroll :on-reach-bottom="handleReachBottom"> -->
    <div class="thesis">
      <ul>
        <li v-for="(item, index) in list_data" :key="index">
          <div class="flex_left">
            <div>
              <p class="list_thesis" @click="pagesList(item)">
                {{ item.title }}
              </p>
              <span v-if="item.periodical">{{ item.periodical }}</span>
              <span style="margin-left: 13px" v-if="item.frequency">{{
                item.frequency
              }}</span>
            </div>
            <div>
              <div class="name_thesis" v-if="item.author">{{ item.author }}</div>
              <!-- <div class="name_thesis" v-if="item.frequency">{{ item.frequency }}</div> -->
            </div>
          </div>
        </li>
        <li style="text-align: center" v-if="listData.length">
          {{ text }} <a v-if="text == '暂无数据'" @click="tizhuan">,查看更多</a>
        </li>
      </ul>
    </div>
    <!-- </Scroll> -->
  </div>
</template>
<script>
var vm;
export default {
  props:["userBehaviorData"],
  data() {
    return {
      commen_list: [],
      perParams: {
        cardId: "",
        pageNo: 1,
        pageSize: 10,
        title: "",
      },
      dataList: {},
      listData: [],
      text: "下拉加载更多",
      list_data: [],
    };
  },
  name: "commends",
  components: {},
  created() {
    vm = this;
  },
  mounted() {
    this.$root.Bus.$on("cardId", function (cardId) {
      vm.perParams.cardId = cardId;
    });
    setTimeout(() => {
      vm.commends();
    }, 1000);

    let _this = this;
    window.onscroll = function () {
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      //滚动条到底部的条件
      if (scrollTop + windowHeight == scrollHeight) {
        setTimeout(function () {
          if (_this.perParams.pageSize == _this.listData.length) {
            _this.perParams.pageNo++;
            _this.commends();
          } else {
            _this.text = "暂无数据";
          }
        }, 2000);
      }
    };
  },

  methods: {
    //论文推荐列表
    commends() {
      this.$root.Bus.$on("cardId", function (cardId) {
        vm.perParams.cardId = cardId;
      });
      vm.$apis.manage.litesyPage(vm.perParams).then((res) => {
        vm.dataList = res.data;
        vm.listData = res.data.list;
        res.data.list.map((res) => {
          this.list_data.push(res);
        });
      });
    },

    tizhuan() {
      var urls =
        location.host.indexOf("cbtest.") != -1 || location.host.indexOf(":80") != -1
          ? "https://test.cnknowledge.com/admin/xsjh?title=%E5%AD%A6%E6%9C%AF%E7%B2%BE%E6%B1%87&id=3"
          : "https://www.cnknowledge.com/xsjh?title=%E5%AD%A6%E6%9C%AF%E7%B2%BE%E6%B1%87&id=3";
      window.open(urls);
    },
    pagesList(data) {
      // 点击推荐，统计用户行为
      this.userBehaviorData.clickName = "推荐文章";
      vm.$apis.manage
        .userBehaviorStatistics(this.userBehaviorData);
      var urls =
        location.host.indexOf("cbtest.") != -1 || location.host.indexOf(":80") != -1
          ? "https://test.cnknowledge.com/thesisDetail?type=0&id="
          : "https://www.cnknowledge.com/details?type=0&id=";
      window.open(urls + data.artId);
    },
    handleReachBottom(e) {
      return new Promise((resolve) => {
        setTimeout(() => {
          vm.perParams.pageNo++;
          vm.$apis.manage.litesyPage(vm.perParams).then((res) => {
            if (res.data.list) {
              res.data.list.map((item) => {
                vm.listData.push(item);
              });
            } else {
              this.text = "数据已经到底了";
              resolve();
            }
          });
          this.text = "数据已经到底了";
          resolve();
        }, 2000);
      });
    },
  },
};
</script>
<style scoped>
.flex_left {
  display: flex;
  justify-content: space-between;
}
.commends {
  width: 100%;
  background: #ffffff;
  padding: 40px;
  margin-bottom: 20px;
}
.column_list {
  margin-top: 40px;
  padding-bottom: 18px;
  border-bottom: 1px solid #d0cece;
}
.column_list img {
  width: 26px;
  height: 26px;
  display: block;
  float: left;
}
.column_list h3 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 30px;
  text-indent: 0.5em;
}
.thesis ul li {
  list-style: none;
  padding: 20px 30px;
  border-bottom: 1px solid #cccccc;
}
.thesis li:last-child {
  border-bottom: none;
}
.list_thesis {
  font-size: 14.5px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
.list_thesis:hover {
  color: #2150cb;
}
.flex_left span {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
}
.name_thesis {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
  margin-top: 30px;
}
</style>
